// Kleine, fehlertolerante Hülle um localStorage (privater Modus, volle Quote, Tests ohne Speicher).
import { useCallback, useState } from 'react'
import { brand } from '@shared/brand'

export const storageKey = (name: string): string => `${brand.storagePrefix}.${name}`

export function readStored<T>(name: string, fallback: T): T {
  try {
    const raw = window.localStorage.getItem(storageKey(name))
    return raw === null ? fallback : (JSON.parse(raw) as T)
  } catch {
    return fallback
  }
}

export function writeStored(name: string, value: unknown): void {
  try {
    if (value === undefined || value === null) window.localStorage.removeItem(storageKey(name))
    else window.localStorage.setItem(storageKey(name), JSON.stringify(value))
  } catch {
    // Speicher nicht verfügbar – die Einstellung gilt dann nur für diese Sitzung
  }
}

/** useState, das seinen Wert je Gerät merkt. Ohne `name` verhält es sich wie useState. */
export function useStoredState<T>(name: string | undefined, initial: T): [T, (next: T) => void] {
  const [value, setValue] = useState<T>(() => (name ? readStored(name, initial) : initial))
  const update = useCallback(
    (next: T) => {
      setValue(next)
      if (name) writeStored(name, next)
    },
    [name],
  )
  return [value, update]
}
